import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

let themes = {
    primary: colors.amber,
    secondary: colors.deepOrange,
    accent: colors.deepPurple,
    error: colors.red,
    warning: colors.pink,
    info: colors.cyan,
    success: colors.blue
};


export default new Vuetify({
    theme: {
        themes: {
            light:themes,
        }
    }
});

